/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OpenAPIv3DeploymentAsset = {
  /**
   * The ID of the uploaded asset.
   */
  assetId: string;
  /**
   * The ID of the deployment asset.
   */
  id: string;
  /**
   * The name to give the document as it will be displayed in UIs.
   */
  name: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
};

/** @internal */
export const OpenAPIv3DeploymentAsset$inboundSchema: z.ZodMiniType<
  OpenAPIv3DeploymentAsset,
  unknown
> = z.pipe(
  z.object({
    asset_id: z.string(),
    id: z.string(),
    name: z.string(),
    slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "asset_id": "assetId",
    });
  }),
);

export function openAPIv3DeploymentAssetFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3DeploymentAsset, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3DeploymentAsset$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3DeploymentAsset' from JSON`,
  );
}
